'use client';

import {useEffect} from 'react';
import app from '../../../package.json';

import {datadogRum} from '@datadog/browser-rum';
import {datadogLogs} from '@datadog/browser-logs';
import {RumErrorEvent} from '@datadog/browser-rum';
import {
  API_SERVICE_URL,
  APPLICATION_ID,
  CLIENT_TOKEN,
  DATADOG_ENV,
  DATADOG_SERVICE,
  DATADOG_SITE,
  DESTINATION_SERVICE,
  PROPERTY_SERVICE,
  SEARCH_SERVICE,
} from './Datadog.constants';

export default function DataDog() {
  const dataDogInitialisation = () => {
    datadogRum.init({
      applicationId: APPLICATION_ID,
      clientToken: CLIENT_TOKEN,
      site: DATADOG_SITE,
      service: DATADOG_SERVICE,
      env: DATADOG_ENV,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: app.version,
      allowedTracingUrls: [
        (url) => url.startsWith(PROPERTY_SERVICE),
        (url) => url.startsWith(SEARCH_SERVICE),
        (url) => url.startsWith(DESTINATION_SERVICE),
        (url) => url.includes(API_SERVICE_URL),
      ],
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',

      beforeSend: (event) => {
        if (event.error) {
          const error = (event as RumErrorEvent).error;
          // filter out error that might be caused by link validation/ pre-fetch rendering from email clicks
          // https://github.com/DataDog/browser-sdk/issues/2715
          const regex =
            /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/;
          if (regex.test(error.message)) return false; // Filter this error out
        }

        return true; // Otherwise, send the event
      },
    });
    datadogRum.setGlobalContext({
      product: 'damascus',
    });
    datadogLogs.init({
      clientToken: CLIENT_TOKEN,
      site: DATADOG_SITE,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      service: DATADOG_SERVICE,
    });
  };

  useEffect(() => {
    dataDogInitialisation();
  }, []);

  return <></>;
}
